module.exports = __webpack_public_path__ + "img/canadian-journal-of-philosophy-cover.c49c37e6.jpg";